var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 320,
    viewBox: "0 0 221 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.863 6.3775C96.0171 5.86301 96.2664 5.46569 96.7938 6.30519C103.127 16.4965 118.547 47.7387 101.405 69.9696C80.6836 96.8452 78.6609 85.9061 65.807 103.827C52.953 121.747 66.9256 127.407 56.553 157.82C46.1804 188.234 8.68493 210.917 13.5963 242.859C18.0942 272.062 42.6199 291.869 70.476 298.921C99.087 306.168 130.933 300.125 146.927 276.1C178.504 228.682 168.03 201.368 165.947 176.4C164.101 154.294 185.542 123.181 201.157 110.117C201.982 109.428 202.092 109.708 201.105 110.112C188.359 115.381 161.691 127.809 155.844 147.122C148.112 172.619 137.996 188.813 136.917 201.38C136.453 166.476 137.729 154.131 149.46 132.914C158.971 115.707 159.422 87.0374 158.75 76.749C158.689 75.7586 157.255 75.9431 156.85 76.8523C152.574 86.5367 138.727 113.16 125.992 122.821C110.399 134.657 100.308 209.648 103.692 218.569C79.8663 180.079 78.3892 173.853 104.547 132.897C130.705 91.9417 136.866 54.457 130.106 36.6172C124.805 22.6032 104.716 11.1711 96.863 6.3775Z",
    fill: "#D34E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9564 196.792C56.9564 196.792 28.6578 229.61 34.8549 250.979C41.052 272.349 64.7264 285.321 84.1276 283.566C103.529 281.81 143.911 261.81 149.468 242.553C155.026 223.295 155.931 205.82 155.931 205.82C155.931 205.82 141.422 238.145 129.431 242.099C117.439 246.053 125.004 199.395 125.004 199.395C125.004 199.395 120.467 242.76 99.7411 241.307C79.0151 239.854 57.0272 220.376 56.9564 196.792Z",
    fill: "#E2EB76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.968 92.5867C101.968 92.5867 81.0958 108.359 79.764 120.974C78.4323 133.59 80.1905 148.496 80.1905 148.496C80.1905 148.496 94.5417 132.786 101.968 92.5867Z",
    fill: "#E2EB76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.244,
    height: 289.706,
    fill: "white",
    transform: "translate(75.7567 0.255249) rotate(15.118)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.055e926fba1fcc09c610eb2264f4e362.svg";
export { ForwardRef as ReactComponent };